// Central constants for forms, editor, and export
export const TONES = [
  { id: "neutral", label: "Neutral" },
  { id: "professional", label: "Professional" },
  { id: "friendly", label: "Friendly" },
  { id: "firm", label: "Firm" },
];

export const READING_LEVELS = [
  { id: "basic", label: "Basic (Grade 6–8)" },
  { id: "standard", label: "Standard (Grade 9–12)" },
  { id: "advanced", label: "Advanced" },
];

export const LANGUAGES_CORE = [
  { id: "en", label: "English" },
  { id: "es", label: "Spanish" },
  { id: "bn", label: "Bengali" },
];

export const DEFAULT_REVISION_CAP = 10;

export const EXPORT_FORMATS = [
  { id: "pdf", label: "PDF" },
  { id: "docx", label: "Word (.docx)" },
  { id: "txt", label: "Plain Text (.txt)" },
  { id: "html", label: "HTML (.html)" },
];

// Feature flags (toggle as you roll out)
export const FEATURES = {
  enableSourcesPanel: true,
  enableClipboardCopy: true,
  enableHtmlSanitizeOnChange: true,
};
